type MsalAuthManagerProps = { children: React.ReactNode };

/**
 * Passthrough wrapper preserved for import-site compatibility.
 *
 * Token management responsibilities have been split into:
 * - `bootstrap-entra-session.ts` — pre-router silent token acquire
 * - `EntraAuthSync` — ongoing refresh loop (mounted in RootLayout)
 * - `LoginEntry` — explicit user-initiated `loginRedirect`
 */
export const MsalAuthManager = ({ children }: MsalAuthManagerProps) => {
  return <>{children}</>;
};
